import TextMessage from './TextMessage';
import ReplyTextMessage from './ReplyTextMessage';
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import appConstants from '../../../../../appConstants';
import { utcToZonedTime } from 'date-fns-tz';
import { format } from 'date-fns';

const Message = (props) => {
  const convertTime = (time) => {
    return format(utcToZonedTime(time, props.terminalOffset), appConstants.DATETYPES.TIME.format);
  };

  const renderReadIcon = (isRead, classes) => {
    return isRead ? (
      <DoneAllIcon className={classes.iconStyle} />
    ) : (
      <DoneIcon className={classes.iconStyle} />
    );
  };

  const getContainerClass = () => {
    const { classes, isMessageHistoryFlow } = props;
    return isMessageHistoryFlow ? classes.scMessageHistory : classes.scMessage;
  };

  const getContentClass = () => {
    const { message, classes } = props;
    let isSentMessage = message.parentMessage?.messageType
      ? message.parentMessage.messageType === appConstants.MESSAGE_TYPE.Dispatcher
      : message.messageType === appConstants.MESSAGE_TYPE.Dispatcher;
    return isSentMessage ? classes.scMessageContentSent : classes.scMessageContentReceived;
  };

  const renderMessageOfType = (data) => {
    return Object.keys(data.parentMessage).length === 0 ? (
      <TextMessage
        msg={data}
        driverName={props.driverName}
        dispatcherName={props.dispatcherName}
        classes={props.classes}
        onReplyMsgSelected={props.onReplyMsgSelected}
        convertTime={convertTime}
        renderReadIcon={renderReadIcon}
        isMessageHistoryFlow={props.isMessageHistoryFlow}
      />
    ) : (
      <ReplyTextMessage
        msg={data}
        classes={props.classes}
        driverName={props.driverName}
        dispatcherName={props.dispatcherName}
        convertTime={convertTime}
        renderReadIcon={renderReadIcon}
        isMessageHistoryFlow={props.isMessageHistoryFlow}
      />
    );
  };

  return (
    <div className={getContainerClass()}>
      <div className={getContentClass()}>{props.message && renderMessageOfType(props.message)}</div>
      {props.isMessageHistoryFlow
        ? null
        : props.unReadCount === props.messageNumber &&
          props.unReadCount > 0 && (
            <div className={props.classes.unReadMsg} ref={props.unReadMessageRef}>
              {props.unReadCount} Unread Message
            </div>
          )}
    </div>
  );
};

export default Message;
